type SearchParamValue = string | number | boolean;

export const withSearchParams = (
  pathname: string,
  parameters: Readonly<Record<string, SearchParamValue>>,
): string => {
  const searchParams = new URLSearchParams(
    Object.entries(parameters).map(([key, value]) => [key, String(value)]),
  );
  const query = searchParams.toString();

  if (!query) return pathname;

  return `${pathname}${pathname.includes("?") ? "&" : "?"}${query}`;
};
